import { MouseEvent, useCallback, useState } from 'react';
import cn from 'classnames';

import { convertQuillDeltaToHtml } from 'functions/convertQuillDeltaToHtml';
import { IReactQuillDelta } from 'APIPackage/KnmModule/interfaces/IReactQuillDelta';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';
import { ViolationStatus } from 'KnmErknmPackage/ErknmViolationsModule/components/ViolationStatus';
import { IKnmErknmFormViolation } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { IconCollapse } from 'UIPackage/IconsModule/components/IconCollapse';
import {
  IKnmErknmFormViolatedRequirementsMandatory,
  IKnmErknmFormViolatedRequirementsNpa,
} from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormViolatedRequirementsNpa';

import styles from './SelectViolationModal.module.scss';

interface IViolationItemProps {
  violation: IKnmErknmFormViolation;
  handleSelect: () => void;
  isSelected: boolean;
  requirementNpa: IKnmErknmFormViolatedRequirementsNpa;
  mandatory: IKnmErknmFormViolatedRequirementsMandatory;
}

export const ViolationItem = ({
  violation,
  handleSelect,
  isSelected,
  requirementNpa,
  mandatory,
}: IViolationItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  /**
   * Функция изменения состояния компонента Открыт/Закрыт
   */
  const onChangeOpen = useCallback((e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(val => !val);
  }, []);

  return (
    <div key={violation.id} className={styles.ViolationItemWrapper}>
      <div className={styles.Row} onClick={handleSelect}>
        <div className={cn(styles.Cell, styles.CellWidthStatus)}>
          <div className={styles.StatusWrapper}>
            <Checkbox checked={isSelected} theme="system" />
            <ViolationStatus status={violation.status} />
          </div>
        </div>
        <div className={cn(styles.Cell, styles.CellWidthDescription)}>
          <div className={styles.DescriptionWrapper}>
            <span>Нарушение №{violation.number}</span>
            <div
              /* eslint-disable-next-line react/no-danger */
              dangerouslySetInnerHTML={{
                __html: convertQuillDeltaToHtml(violation.descriptionReactQuillEditor as IReactQuillDelta),
              }}
            />
          </div>
          <div className={cn(styles.Arrow, { [styles.ArrowRotate]: isOpen })} onClick={onChangeOpen}>
            <IconCollapse className={styles.OpenButtonIcon} />
          </div>
        </div>
      </div>
      {isOpen && (
        <div className={styles.InnerWrapper}>
          <div className={styles.BoldNpaText}>{requirementNpa.npa.title}</div>
          <span className={styles.GrayNpaText}>
            Структурная единица <span className={styles.BoldNpaText}>{requirementNpa.structuralUnit.title}</span>
          </span>

          <div className={styles.RequireViolationWrapper}>
            <div className={styles.GrayNpaText}>Нарушенные обязательные требования</div>

            <div className={cn(styles.RequirementsItemBlock)}>
              <div className={styles.NpaBlock}>
                <div className={styles.RequirementsHeader}>
                  <span className={styles.GreyHeader}>Содержание требования</span>
                </div>
                {mandatory.mandatory.title}
              </div>
              <div className={styles.StructuralUnitBlock}>
                <div className={styles.RequirementsHeader}>
                  <span className={styles.GreyHeader}>Значимость последствий нарушения</span>
                </div>

                <div className={styles.RequirementsValueWrapper}>{mandatory.category?.label}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
